import classNames from 'classnames';
import { customizeElement } from 'utilities/customizeElement';
import styles from './ShortcutCardSimple.module.scss';

export interface ShortcutCardSimpleProps {
	className?: string;
	id: string;
	linkText: string;
	link: React.ReactElement;
}

export const ShortcutCardSimple: React.FC<ShortcutCardSimpleProps> = ({ className, link, linkText }) => {
	return customizeElement({
		element: link,
		style: classNames(styles.ShortcutCardSimple, className),
		children: (
			<>
				<div className={styles.ShortcutCardSimple_textbox}>{linkText}</div>
			</>
		),
	});
};
